import React, { useState, type FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { JobList } from 'components';
import { useJobSearch } from 'helpers';

export namespace CustomerJobs {
  export type Props = Readonly<{
    customerId?: string;
  }>;

  export const $: FC<Props> = (props) => {
    const { customerId } = props;

    const [page, setPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(5);

    const [jobs, total = 0] = useJobSearch({
      searchBy: 'customer_id',
      searchValue: customerId,
      page,
      recordsPerPage,
    });

    const paginationMetadata: JobList.Props['paginationMetadata'] = {
      current_page: page,
      onChange(page, pageSize) {
        setPage(page);
        setRecordsPerPage(pageSize);
      },
      pageSize: recordsPerPage,
      total,
    };

    return (
      <>
        <Helmet>
          <title>Customer Jobs</title>
        </Helmet>
        <JobList.$ jobs={jobs} paginationMetadata={paginationMetadata} hideColumns={['customerName', 'address']} />
      </>
    );
  };
}
